<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title v-ripple style="cursor: pointer" @click="fetchData(onlyTrashed)">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">{{pluralName}} {{onlyTrashed ? ' removidas' : ''}}</span>
                    </template>
                    <span>Clique para actualizar</span>
                </v-tooltip>
            </v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="mr-2 mb-2" fill-height
                  v-model="search"
                  append-icon="search"
                  :label=searchText
                  clearable
                  single-line
                  hide-details
            ></v-text-field>

            <!--Dialog for add and edit-->
            <v-btn v-if="!onlyTrashed && permissionToAdd" color="primary" icon @click="openModal"><v-icon>add</v-icon></v-btn>
            <a-t-form-modal
                :paymentConditions="paymentConditions"
                :paymentMethods="paymentMethods"
                :sell-channels="sellChannels"
                :active_states="active_states"
                :currencies="currencies"
                :operationTypes="operationTypes"
                :typologies="typologies"
                :countries="countries"
                :cities="cities"
                @onFormModalDone="formModalCallback($event)"
                :entity-search-url="entitySearchUrl"
                :name="name"
                :plural-name="pluralName"
                :madeByLabel="madeByLabel"
                :save-url="saveUrl"
                :has-discount="hasDiscount"
                :modal-title="modalTitle"
                :entity-name="entityName"
                :article-transaction-type="articleTransactionType"
                :autoFillDataBudgetCode="autoFillBudgetCode"
            ></a-t-form-modal>
        </v-toolbar>

        <!--Data table-->
        <v-data-table xs12 sm6 md4
            :headers="headers"
            :items="sells"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText()"
            :no-results-text="noDataText()"
            rows-per-page-text="por página"
            :rows-per-page-items="Global.ROWS_PER_PAGE"
            :pagination.sync="pagination"
            hide-actions
            disable-initial-sort
            :total-items="3"
        >
            <v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" >
                <td class="text-xs-left">{{ props.item.code }}/{{ props.item.series }}</td>
                <td class="text-xs-left">{{ props.item.client ? props.item.client.name : '-----'}}</td>
                <td class="text-xs-center">{{ props.item.type_situation ? props.item.type_situation.name : '------'}}</td>
                <td class="text-xs-right">{{ props.item.total_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                <td class="text-xs-right" v-if="articleTransactionType === Global.ARTICLE_TRANSACTION_PURCHASE">
                    <span v-if="!props.item.file_path" style="color: #7b7b7b; font-size: 11px"> Sem comprovativo </span>
                    <v-btn v-else icon v-bind:href="props.item.file_path" target="_blank" style="margin-right: 30px">
                        <v-icon small color="blue darken-1">description</v-icon>
                    </v-btn>
                </td>
                
                <td class="text-xs-right">{{ props.item.created_at | formatDate}}</td>
                <td class="text-xs-right">
                    <v-icon v-if="!onlyTrashed" small class="mx-2" @click="showItem(props.item)">visibility</v-icon>
                    <v-icon v-if="articleTransactionType === Global.ARTICLE_TRANSACTION_BUDGET" v-ripple small class="mx-2" @click.stop="showBudgetDoc(props.item)">open_in_new</v-icon>
                    <!--<v-icon v-if="!onlyTrashed" small class="mr-2" @click="editItem(props.item)">edit</v-icon>-->
                    <!--<v-icon v-if="!onlyTrashed" small class="mr-2" @click="deleteItem(props.item)">block</v-icon>-->
                    <!--<v-icon v-if="onlyTrashed" small class="mr-2" @click="restoreTrashedItem(props.item)">replay</v-icon>-->
                    <!--<v-icon v-if="onlyTrashed" small class="mr-2" @click="deleteTrashedItem(props.item)">delete</v-icon>-->
                </td>
            </template>
            <template v-slot:footer>
                <td :colspan="headers.length">
                    <custom-pagination
                        :totalData="totalData"
                        @onPaginationChange="paginationChangeCallBack($event)"
                        :disabled="loading"
                    ></custom-pagination>
                </td>
            </template>
            <template v-if="error_fetching" slot="no-data">
                <v-btn flat color="primary" @click="fetchData(onlyTrashed)"><v-icon>refresh</v-icon></v-btn>
                <span class="text-xs-center">nenhum dado encontrado</span>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
        </div>

        <!--Confirmation Dialog-->
        <v-dialog persistent max-width="290" v-model="openConfirmationDialog" @close="openConfirmationDialog = false">
            <v-card>
                <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                <v-card-text class="text-xs-center">
                    <p v-if="confirmationModalOp === 1">Tens a certeza que queres eliminar a venda de código <br> <b>{{selectedSell.code}}</b>?</p>
                    <p v-if="confirmationModalOp === 2">Tens a certeza que queres <br> <span class="green--text text--darken-2">restaurar</span> a venda de código <br><b>{{selectedSell.code}}</b>?</p>
                    <p v-if="confirmationModalOp === 3">Tens a certeza que queres <br> <span class="red--text text--darken-2">eliminar permanentemente</span><br> a venda de código <br><b>{{selectedSell.code}}</b>?</p>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn color="red darken-1" flat @click="confirmationDialogYes">Sim</v-btn>
                        <v-btn color="grey darken-1" flat @click="close">Não</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <budget-modal></budget-modal>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import {Permissions, Global} from "../../config";
    import ATFormModal from '../article_transaction/ATFormModal';
    import BudgetModal from '../budget/BudgetModal';
    import CustomPagination from '../extra/CustomPagination.vue';

    export default {
        name: "ATList",
        created () {
            this.selectedCompany = this.getNewCompany();
            this.selectedSell = this.getNewSell();
            // this.fetchData(false);
            this.sells = [];

            this.autoFillData = this.$route.params.budgetParams;
        },
        beforeDestroy(){
            this.close();
        },

        data(){
            return {
                Global,
                Permissions,
                pagination: {},
                totalData: 0,
                autoFillData: null,
                loading: false, //loading for list of sells in the datatable
                loading_modal: false, //loading for the action buttons in form modal
                error_fetching: false,  //error for fetching list of sells in the datatable
                search: '', //search for the datatable
                awaitingSearch: false,
                openConfirmationDialog: false, //loads confirmation modal with yes or no

                sells: [],
                paymentConditions: [],
                paymentMethods: [],
                sellChannels: [],
                situations: [],
                active_states: [{id: 0, name: 'inativo'}, {id: 1, name: 'ativo'}],
                countries: [],
                cities: [],
                currencies: [],
                operationTypes: [],
                typologies: [],
                selectedIndex: -1, //the index of the selected sell, useful for delete, add, update, restore, permanently delete
                onlyTrashed: false, //displays only trashed items or not
                confirmationModalOp: 0, //used for getting the confirmation actions (delete, restore, permanently delete) from confirmation modal

            }
        },

        props: {
            modalTitle: String,
            name: String,
            pluralName: String,
            madeByLabel: String,
            fetchUrl: String,
            fetchTrashedUrl: String,
            saveUrl: String,
            articleTransactionType: Number,
            entitySearchUrl: String,
            entityName: String,

            atViewPermission: Boolean,
            atAddPermission: Boolean,

            hasDiscount: {
                type: Boolean,
                default: true,
            }
        },

        components: {
            ATFormModal,
            BudgetModal,
            CustomPagination,
            // ConfirmationDialog,
        },

        watch: {
            showSellModal(){
                if(!this.showSellModal){
                    //clear autoFillData when modal is closed
                    this.autoFillData = null;
                }
            },
            search() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.fetchData();
                }, 800);
            },
            pagination(){
                this.fetchData();
            }
        },

        computed: {
            ...mapGetters([
                'getNewUser',
                'getToken'
            ]),

            
            headers() {
                if(this.articleTransactionType === Global.ARTICLE_TRANSACTION_PURCHASE){
                    return [
                        { text: 'Código', align: 'left', value: 'code' },
                        { text: 'Cliente', align: 'left', value: 'client.name'},
                        { text: 'Situação', align: 'center', value: 'type_situation.name'},
                        { text: 'Valor', align: 'right', value: 'total_value'},
                        { text: 'Comprovativo', align: 'right', value: 'file'},
                        { text: 'Adicionado em', align: 'right', value: 'created_at' },
                        { text: 'Ações', align: 'right', value: '', sortable: false }
                    ];
                    
                }

                return [
                    { text: 'Código', align: 'left', value: 'code' },
                    { text: 'Cliente', align: 'left', value: 'client.name'},
                    { text: 'Situação', align: 'center', value: 'type_situation.name'},
                    { text: 'Valor', align: 'right', value: 'total_value'},
                    { text: 'Adicionado em', align: 'right', value: 'created_at' },
                    { text: 'Ações', align: 'right', value: '', sortable: false }
                ];
            }, 

            autoFillBudgetCode(){
                if(!this.autoFillData) return null;
                return this.autoFillData.budget.code+'/'+this.autoFillData.budget.series;
            },
            permissionToAdd(){
                return this.hasPermission(Permissions.SELL_ADD);
            },
            searchText(){
                return "procurar "+this.pluralName+"...";
            },
            showSellModal: {
                get(){
                    return this.$store.getters.getShowSellModal;
                },
                set(value){
                    this.$store.dispatch('setShowSellModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            selectedSell: {
                get(){
                    return this.$store.getters.getSelectedSell;
                },
                set(value){
                    this.$store.dispatch('setSelectedSell', value);
                }
            },
            sellShow: {
                get(){
                    return this.$store.getters.getSellShow;
                },
                set(value){
                    this.$store.dispatch('setSellShow', value);
                }
            },
            articles: {
                get(){
                    return this.$store.getters.getArticles;
                },
                set(value){
                    this.$store.dispatch('setArticles', value);
                }
            },
            selectedBudget: {
                get(){
                    return this.$store.getters.getSelectedBudget;
                },
                set(value){
                    this.$store.dispatch('setSelectedBudget', value);
                }
            },
            showBudgetModal: {
                get(){
                    return this.$store.getters.getShowBudgetModal;
                },
                set(value){
                    this.$store.dispatch('setShowBudgetModal', value);
                }
            },
        },

        methods: {

            checkAutoFillData(){
                this.selectedSell = this.selectedBudget;
                if(!this.autoFillData) return;
                this.showSellModal = true;
            },

            paginationChangeCallBack(payload){
                this.pagination.rowsPerPage = payload.byPage;
                this.pagination.page = payload.currentPage;
                this.fetchData();
            },
            
            noDataText(){
                return this.loading ? 'a carregar '+this.pluralName+'...' : 'nenhum '+this.name+'.';
            },

            getNewSell(){
                return {
                    code: '',
                    clients_id: '',
                    sell_date: '',
                    deadline: '',
                    sell_tax: '',
                    employees_id: '',
                    types_situation_id: '',
                    types_sell_channel_id: '',
                    types_payment_condition_id: '',
                    types_paymet_method_id: '',
                    transport: '',
                    transport_cost:  '',
                };
            },

            getNewCompany(){
                return {
                    id: '',
                    name: '',
                    company_types_id: '',
                    company_categories_id: '',
                    nib_bi: '',
                    nif: '',
                    state: '',
                    countries_id: '',
                    cities_id: '',
                    address: '',
                    contacts_json: [{ name:'Empresa',  contactLines: [ { phone: '', mobile_phone: '', email: '', fax: ''} ] }],
                    description: '',
                    last_article_code: '',
                    last_invoice_code: '',
                    last_receipt_code: '',
                    created_at: '',
                };
            },

            formModalCallback(payload){
                this.fetchData();
                // this.consoleLog('formModalCallback  payload.selectedItem::', payload.selectedItem);
                //open budget modal (paper)
                if(payload.articleTransactionType === Global.ARTICLE_TRANSACTION_BUDGET){
                    this.selectedBudget = payload.selectedItem;
                    this.showBudgetModal = true;
                }
            },

            fetchData(onlyTrashed = false){
                if(this.loading) return;
                this.onlyTrashed = onlyTrashed;
                let url = onlyTrashed ? 'sell/trashed' : this.fetchUrl;

                this.sells = [];
                this.loading = true;
                this.error_fetching = false;
                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                Vue.axios.get(url, {
                    params: {
                        pag_size: this.pagination.rowsPerPage,
                        pag_current: this.pagination.page,
                        sort_field: this.getSortBy(this.pagination),
                        sort_order: this.getSortDes(this.pagination),
                        search: this.search,
                    }
                })
                .then(response => {
                    this.consoleLog(response);
                    if(!response.data.success){
                        this.loading = false;
                        this.error_fetching = true;
                        this.handleErrorCodeMessage(response.data);
                        return;
                    }

                    if(onlyTrashed){
                        this.sells = response.data.response;
                    }else {
                        this.sells = response.data.response.sells;
                        this.countries = response.data.response.countries;
                        this.cities = response.data.response.cities;

                        this.paymentConditions = response.data.response.types.purchaseCondition;
                        this.paymentMethods = response.data.response.types.purchaseMethod;
                        this.sellChannels = response.data.response.types.sellChannel;
                        this.situations = response.data.response.types.sellSituation;
                        this.currencies = response.data.response.types.currency;
                        this.operationTypes = response.data.response.types.operationType;
                        this.typologies = response.data.response.types.typology;
                        this.articles = response.data.response.articles;

                        this.totalData = response.data.response.total_data;
                    }

                    this.totalRows = this.sells.length;
                    this.loading = false;
                    this.checkAutoFillData();
                }).catch(error => {
                    this.consoleLog(error);
                    this.loading = false;
                    this.error_fetching = true;
                    this.showSnackBar('Erro ao carregar lista de '+this.pluralName, 'error');
                });
            },

            delete(){
                try{
                    this.loading_modal = true;
                    let code = this.selectedSell.code;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.delete('sell/'+this.selectedSell.id)
                        .then(response => {
                            this.consoleLog(response);
                            if(!response.data.success){
                                this.showSnackBar('Erro ao remover venda', 'error');
                                return;
                            }
                            this.sells.splice(this.selectedIndex, 1);
                            this.showSnackBar(this.name+' de código ['+code+'] removido com sucesso', 'success');
                        }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao remover venda', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedSell = this.getNewSell();
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao remover venda!', 'error');
                    this.loading_modal = false;
                }
            },

            restoreTrashed(){
                try{
                    this.loading_modal = true;
                    let code = this.selectedSell.code;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('sell/trashed/restore/'+this.selectedSell.id)
                        .then(response => {
                            if(!response.data.success){
                                // this.$toastr.error('Erro ao remover venda', '');
                                this.loading_modal = false;
                                return;
                            }
                            this.sells.splice(this.selectedIndex, 1);
                            this.showSnackBar(this.name+' de código ['+code+'] restaurado com sucesso', 'success');
                        }).catch(error => {
                        // this.consoleLog(error);
                        this.showSnackBar('Erro ao restaurar venda', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedIndex = -1;
                        this.selectedSell = this.getNewSell();
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao restaurar venda!', 'error');
                    this.loading_modal = false;
                }
            },

            deleteTrashed(){
                try{
                    this.loading_modal = true;
                    let code = this.selectedSell.code;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.delete('sell/trashed/delete/'+this.selectedSell.id)
                        .then(response => {
                            if(!response.data.success){
                                this.$toastr.error('Erro ao remover venda', '');
                                this.loading_modal = false;
                                return;
                            }
                            this.sells.splice(this.selectedIndex, 1);
                            this.showSnackBar(this.name+' de código ['+code+'] foi eliminado permanentemente com sucesso', 'success');
                        }).catch(error => {
                        this.showSnackBar('Erro ao eliminar permanentemente o venda', 'error');
                        // this.consoleLog(error);
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedIndex = -1;
                        this.selectedSell = this.getNewSell();
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao eliminar permanentemente a venda!', 'error');
                    this.loading_modal =false;
                    // this.consoleLog(e);
                }
            },

            getContactsJson(item){
                if(!item.contacts_json) return [];
                if(item.contacts_json instanceof Array)
                    return item.contacts_json;
                else
                    return JSON.parse(item.contacts_json);
            },

            setTypologyAndOperationType(){
                let foundTypology = null;
                let foundOperationType = null;

                for(let i=0; i<this.typologies.length; i++){
                    this.consoleLog('typology: '+i);
                    if(this.typologies[i].id === this.selectedSell.types_typology_id){
                        foundTypology = this.typologies[i];
                        break;
                    }
                }

                for(let i=0; i<this.operationTypes.length; i++){
                    this.consoleLog('operationTypes: '+i);
                    if(this.operationTypes[i].id === this.selectedSell.types_operation_type_id){
                        foundOperationType = this.operationTypes[i];
                        break;
                    }
                }

                this.selectedSell.typology = foundTypology;
                this.selectedSell.operation_type = foundOperationType;
            },

            showItem (item) {
                this.consoleLog('showItem: ', item);
                this.sellShow = true;
                this.selectedIndex = this.sells.indexOf(item);
                this.selectedSell = item;

                let foundTypology = null;
                for(let i=0; i<this.typologies.length; i++){
                    if(this.typologies[i].id === this.selectedSell.types_typology_id){
                        foundTypology = this.typologies[i];
                        break;
                    }
                }

                let foundOperationType = null;
                for(let i=0; i<this.operationTypes.length; i++){
                    if(this.operationTypes[i].id === this.selectedSell.types_operation_type_id){
                        foundOperationType = this.operationTypes[i];
                        break;
                    }
                }
                this.selectedSell.typology = foundTypology;
                this.selectedSell.operation_type = foundOperationType;
                this.showSellModal = true
            },

            showBudgetDoc(item){
                this.consoleLog('opening BudgetPaper', item);
                this.selectedBudget = item;
                this.showBudgetModal = true;
            },

            editItem (item) {
                this.selectedIndex = this.sells.indexOf(item);
                this.selectedSell = item;

                // this.selectedSell.contacts_json = this.getContactsJson(item);
                // this.selectedSell.typology = this.operationTypes;
                // this.selectedSell.typology = this.typology;

                this.setTypologyAndOperationType();

                this.showSellModal = true
            },

            deleteItem (item) {
                this.confirmationModalOp = 1;
                this.selectedIndex = this.sells.indexOf(item);
                // this.$store.dispatch('setSelectedSell', item);
                this.selectedSell = item;
                this.openConfirmationDialog = true;
            },

            restoreTrashedItem (item){
                this.confirmationModalOp = 2;
                this.selectedIndex = this.sells.indexOf(item);
                this.selectedSell = item;
                this.openConfirmationDialog = true;
            },

            deleteTrashedItem (item){
                this.confirmationModalOp = 3;
                this.selectedIndex = this.sells.indexOf(item);
                this.selectedSell = item;
                this.openConfirmationDialog = true;
            },

            close () {
                this.showSellModal = false;
                this.openConfirmationDialog = false;
                this.loading = false;
                this.sellShow = false;
                if(this.$v) this.$v.$reset();
                setTimeout(() => {
                    this.selectedSell = this.getNewSell();
                    this.selectedIndex = -1
                }, 300)
            },

            openModal(){
                this.consoleLog('sellChannels::: ', this.sellChannels);
                this.selectedSell = this.getNewSell();
                this.showSellModal = true;
            },

            getNewEmptyContact(){
                return { phone: '', mobile_phone: '', email: '', fax: ''}
            },

            confirmationDialogYes(){
                if(this.confirmationModalOp === 1){
                    this.delete();
                }else if(this.confirmationModalOp === 2){
                    this.restoreTrashed();
                }else if(this.confirmationModalOp === 3){
                    this.deleteTrashed();
                }
            },

        },
    }
</script>

<style scoped>

</style>